<app-modal-header (closeModal)="close()"> </app-modal-header>
<app-modal-body>
  <h1 class="fs-5 text-truncate pe-2" [innerHTML]="header | translate"></h1>
  <p class="mb-0" [innerHTML]="description | translate"></p>
</app-modal-body>
<app-modal-footer classList="d-flex justify-content-center">
  <button type="button" class="btn btn-primary rounded-5 fw-medium" (click)="close()">{{ 'CLOSE' | translate }}</button>
</app-modal-footer>
